<template >
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>

    <h2>{{ $t("workflow.processList") }}</h2>

    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
      >
        <template #thead-top>
          <b-tr style="">
            <b-th />
            <b-th>
              <b-form-input
                v-model="tableFilters.displayName"
                type="text"
                placeholder="Filtrar pelo Nome:"
              />
            </b-th>

            <b-th>
              <div>
                <b-form-select
                  v-model="tableFilters.active"
                  :options="optionsBoolean"
                />
              </div>
            </b-th>
          </b-tr>
        </template>

        <template v-slot:cell(actions)="data">
          <!-- {{ data.item.permissions }} -->
          <b-button
            size="sm"
            class="btn-checklist"
            @click="getUrlEdit(data.item)"
            :disabled="!isAdmin(data.item.permission)"
          >
            {{ $t("geral.edit") }}
          </b-button>
          <router-link :to="'/workflow/Create/' + data.item.id">
            <b-button size="sm" class="btn-checklist ml-2"> Clonar </b-button>
          </router-link>
          <b-button
            class="ml-2"
            size="sm"
            @click="remove(data.item.id)"
            :disabled="!isAdmin(data.item.permission)"
          >
            Excluir
          </b-button>
          <!-- <b-button
            size="sm"
            class="btn-checklist ml-2"
            @click="getUrlFill(data.item)"
            :disabled="!canFill(data.item.permission)"
          >
            Preencher
          </b-button> -->
        </template>
      </b-table>
    </b-row>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>
<script>
export default {
  name: "ProcessList",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data: function () {
    return {
      sortBy: "displayName",
      sortDesc: false,
      alert: {
        error: "",
        success: "",
      },
      optionsBoolean: [
        {
          value: 2,
          text: "Todos",
        },
        { value: 1, text: "Sim" },
        { value: 0, text: "Não" },
      ],
      fields: [
        {
          key: "actions",
          label: "",
          thStyle: "width: 260px",
        },
        {
          key: "displayName",
          filterKey: "displayName",
          sortable: true,
          label: "Nome",
        },
        {
          key: "active",
          sortable: true,
          label: "Ativo",
          thStyle: "width: 110px",
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      process: [],
      isBusy: false,
      tableFilters: {
        id: 0,
        displayName: "",
        active: 1,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {},
  methods: {
    canEdit(permissions) {
      permissions.forEach((p) => {
        return p.administrador;
      });
      // return false;
      // console.log(p);
    },
    canFill(permission) {
      if (this.isAdmin(permission)) return true;
      if (permission.gestor) return true;
      if (permission.AdvancedOperator) return true;
      return false;
    },
    getUrlEdit(process) {
      this.$router.push(`/workflow/process/edit/${process.id}`);
    },
    getUrlFill(process) {
      this.$router.push(`/workflow/process/Fill/${process.id}`);
    },
    isAdmin(permission) {
      if (permission.administrador) return true;
      if (this.$store.getters.isAdministrator) return true;
      return false;
    },
    remove(id) {
      this.$apiWorkflow
        .post("/process/delete/" + id)
        .then((response) => {
          this.alert.success = "Processo excluído";
          this.$refs.alert.show();
          this.$refs.table.refresh();
          this.$forceUpdate();
        })
        .catch((error) => {
          this.alert.error = error.message;
          this.$refs.danger.show();
        });
    },
    myProvider(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        activeVM: ctx.filter.active,
        displayNameVM: ctx.filter.displayName,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      };
      this.$apiWorkflow
        .post("/process/list", apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          console.log("Error");
          console.log(error.response);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
  },
};
</script>